import type {
  ApiResponse,
  CryptoRate,
  UpdateCryptoRateRequest
} from '../../types/ApiTypes';
import { apiManager } from '../api/ApiManager';

export class CryptoService {
  async getCryptoRates(): Promise<ApiResponse<CryptoRate[]>> {
    return apiManager.get<CryptoRate[]>('/api/v1/admin/crypto/rates');
  }

  async updateBuyRate(data: UpdateCryptoRateRequest): Promise<ApiResponse> {
    return apiManager.put('/api/v1/admin/crypto/buy-rate', data);
  }

  async updateSellRate(data: UpdateCryptoRateRequest): Promise<ApiResponse> {
    return apiManager.put('/api/v1/admin/crypto/sell-rate', data);
  }
}

export const cryptoService = new CryptoService();